var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input_check"},[_c('input',{ref:"checkbox",attrs:{"type":"checkbox","id":_vm.id,"disabled":_vm.disabled},on:{"change":function($event){return _vm.$emit('custom-checked', !_vm.checked)}}}),_c('label',{class:{
      checked: _vm.checked,
      disabled: _vm.disabled,
    },attrs:{"for":_vm.id},domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }